import { Cookies } from 'react-cookie';
import { Observable } from 'rxjs';
import { AjaxConfig, AjaxResponse } from 'rxjs/ajax';

import { AppStore } from 'app/store';

import { HttpHandler } from '../http-handler';
import { Interceptor } from '../interceptor';

export class XdebugInterceptor implements Interceptor {
    private cookieService = new Cookies();

    public intercept<T>(store: AppStore, req: AjaxConfig, next: HttpHandler<T>): Observable<AjaxResponse<T>> {
        const xdebugKey = this.cookieService.get('XDEBUG_SESSION') as string | undefined;

        if (!xdebugKey) {
            return next.handle(req);
        }

        if (!req.url) {
            return next.handle(req);
        }

        req.url += -1 === req.url.search('\\?') ? '?' : '&';
        req.url += `XDEBUG_SESSION_START=${xdebugKey}`;

        return next.handle(req);
    }
}
